import React from 'react';

import { EScreenTypes } from '@enum';

import { LogoProps } from '@assets/icons/logo/Logo.types';

import { ReactComponent as SiteLogo } from './logo.svg';
import { ReactComponent as IconLogo } from './icon.svg';
import { ReactComponent as ShortLogo } from './short_logo.svg';

export const Logo = ({ type }: LogoProps) => {
  if (type === EScreenTypes.desktop) return <SiteLogo />;
  if (type === EScreenTypes.tablet) return <ShortLogo />;
  return <IconLogo />;
};
